import { render, staticRenderFns } from "./TheLayoutVertical.vue?vue&type=template&id=68ff1af8&"
import script from "./TheLayoutVertical.vue?vue&type=script&lang=js&"
export * from "./TheLayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutVertical.vue?vue&type=style&index=0&id=68ff1af8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports